// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planRecoveryList[data-v-b3c11bb6] .product_body {\n  top: 1.1rem !important;\n}\n.searchTravel[data-v-b3c11bb6] {\n  display: inline-block;\n  height: 0.28rem;\n  line-height: 0.28rem;\n  margin-left: 0.2rem;\n  text-shadow: 2px 2px 5px #999;\n  color: #f54402;\n  font-weight: bold;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
